<template>
  <div>
    <h3
      style="text-transform: uppercase; margin-bottom: 12px; margin-top: 28px;"
    >
      Facebook Ad Preview
    </h3>
    <div v-if="facebookPreview">
      <div v-html="facebookPreview"></div>
    </div>
    <div v-else>
      <p
        style="letter-spacing: 0px; font-size: 12px; text-transform: uppercase;"
      >
        <span v-if="fetchingPreview">Fetching Preview...</span>
        <a
          href="#"
          @click.prevent="fetchFacebookPreview()"
          v-if="!fetchingPreview"
          >Fetch Signifi Preview</a
        >
      </p>
      <div v-if="noNewPreviewAvailable">
        <p
          style="letter-spacing: 0px; font-size: 12px; text-transform: uppercase;"
        >
          No Facebook Ad Preview available
        </p>
      </div>
      <div v-if="error">
        <p
          style="letter-spacing: 0px; font-size: 12px; text-transform: uppercase; color: red;"
        >
          Error fetching Facebook Ad Preview
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import CampaignServiceV2 from '../../services/V2/CampaignServiceV2';

export default {
  data() {
    return {
      fetchingPreview: false,
      error: false,
      facebookPreview: null,
      noNewPreviewAvailable: false,
    };
  },
  props: ['id', 'facebookPreviewIframe'],
  computed: {},
  methods: {
    async fetchFacebookPreview() {
      this.fetchingPreview = true;
      this.noNewPreviewAvailable = false;
      this.error = false;
      try {
        const response = await CampaignServiceV2.getCampaignPreviews(this.id);
        console.log(
          '🚀 ~ fetchFacebookPreview ~ response:',
          response.data.data.signifiPreviewFacebookIframe
        );
        if (
          response.data &&
          response.data.data &&
          response.data.data.signifiPreviewFacebookIframe
        ) {
          this.facebookPreview =
            response.data.data.signifiPreviewFacebookIframe;
        } else {
          this.noNewPreviewAvailable = true;
        }
      } catch (error) {
        this.error = true;
      } finally {
        this.fetchingPreview = false;
      }
    },
  },
  mounted() {
    if (!this.facebookPreviewIframe) {
      this.fetchFacebookPreview();
    }
  },
};
</script>
